import { useState } from "react";
import PdfIcon from "./PdfIcon";
import "../assets/InvoiceItem.css";

export default function InvoiceItem({ invoice }) {
  const [isModalOpen, setIsModalOpen] = useState(false);

  const fileName = invoice.key.split("/").pop();
  const lastModified = new Date(invoice.lastModified).toLocaleString("it-IT");
  
  const handleDownload = async (invoice) => {
    console.log("Downloading invoice:", invoice.key);
    try {
      const url = "https://homelab.accesso-italiano.it/gui/invoices/download?objectKey=" + encodeURIComponent(invoice.key);
      const res = await fetch(url, {
        method: "GET",
        headers: { "X-EXT-APP-KEY": "ai-netlify-app" },
      });

      if (!res.ok) throw new Error("Errore durante il download del file");

      const blob = await res.blob(); // otteniamo il file come blob
      const downloadUrl = window.URL.createObjectURL(blob);

      const link = document.createElement("a");
      link.href = downloadUrl;
      link.download = invoice.key.split("/").pop(); // nome del file
      document.body.appendChild(link);
      link.click(); // forza il download
      link.remove();
      window.URL.revokeObjectURL(downloadUrl);

    } catch (err) {
      console.error(err);
    }
  };


  const handleClose = () => setIsModalOpen(false);

  return (
    <>
      <div
        className="invoice-item"
        onClick={() => setIsModalOpen(true)}
        style={{ cursor: "pointer" }}
      >
        <PdfIcon className="pdf-icon" />
        <div className="invoice-info">
          <p className="invoice-name">{fileName}</p>
          <p className="invoice-date">{lastModified}</p>
        </div>
      </div>

      {isModalOpen && (
        <div className="modal-overlay">
          <div className="custom-modal-content">
            <h2>Dettagli Fattura</h2>
            <p><strong>Nome file</strong><br/>{fileName}</p>
            <p><strong>Ultima modifica</strong><br/>{lastModified}</p>

            <div className="modal-buttons">
              <button onClick={() => handleDownload(invoice)} className="modal-btn donwload-btn">
                <svg width="30" height="30" viewBox="0 0 24 24">
                  <path 
                    d="M5 20h14v-2H5v2zm7-18v12l5-5h-3V2h-4v7H7l5 5z"
                    fill="#26b613ff"
                  />
                </svg>
                </button>

              <button onClick={handleClose} className="modal-btn close-btn">
                <svg width="30" height="30" viewBox="0 0 24 24">
                  <path 
                      d="M18 6 L6 18 M6 6 L18 18" 
                      stroke="#c41d1dff" 
                      strokeWidth="2" 
                      strokeLinecap="round"
                    />      
                </svg>
              </button>
            </div>
          </div>
        </div>
      )}

    </>
  );
}
